import { Button } from '..'
import CanonicalModal from '../CanonicalModal/CanonicalModal'

type ResendInviteModalProps = {
	open: boolean
	onCancel: () => void
	onConfirm: () => void
	fullName?: string
	email?: string
	signupUrl?: string
	isExpired?: boolean
}

/**
 * Shared "Resend invite"/"Renew invite" confirmation modal (Sub-task I, docs/todo/
 * user-org-membership-i-qa-actions.md item A.3) - used by both AdminTrainingSessionUsers.tsx and
 * AdminUsers.tsx so both an admin invitation and a supply-chain invitation resend look identical,
 * regardless of which backend endpoint the caller's `onConfirm` actually hits. Shows the
 * invitation's *current* signup link (not yet regenerated) - confirming invalidates it and emails
 * a fresh one, mirroring the existing resendInvite.ts/resendSupplyChainInvite.ts lib behaviour.
 */
function ResendInviteModal({
	open,
	onCancel,
	onConfirm,
	fullName,
	email,
	signupUrl,
	isExpired,
}: ResendInviteModalProps) {
	const title = isExpired ? 'Renew invite' : 'Resend invite'
	const subtitle = [fullName, email].filter(Boolean).join(' ') || undefined

	return (
		<CanonicalModal
			open={open}
			onClose={onCancel}
			title={title}
			subtitle={subtitle}
			actions={
				<>
					<Button type='Primary' size='sm' text={title} onClick={onConfirm} additionalClass='mr-5' />
					<Button type='Outlined' size='sm' text='Cancel' onClick={onCancel} />
				</>
			}
		>
			<p className='text-white mt-8'>
				{isExpired
					? 'This invitation has expired. Sending a new one will invalidate the expired link below.'
					: 'Are you sure you want to resend this invitation? This will invalidate the link below and generate a new one.'}
			</p>
			{signupUrl && (
				<div className='mt-8'>
					<h4 className='text-sm text-charcoal-100 my-1'>Unique signup link</h4>
					<div className='bg-charcoal-700 rounded p-4 text-charcoal-100 text-sm break-all font-mono'>
						{signupUrl}
					</div>
				</div>
			)}
		</CanonicalModal>
	)
}

export default ResendInviteModal
